import { Box, Typography } from '@material-ui/core'
import React from 'react'
import { useGlobalStyles } from 'src/styles/theme'

export interface AnnouncementContentCellProps {
  value: string
}
export const AnnouncementContentCell = ({ value }: AnnouncementContentCellProps) => {
  const globalClasses = useGlobalStyles()
  return (
    <Box width={1} whiteSpace="pre-wrap" className={globalClasses.lineclamp1}>
      <Typography style={{ fontSize: '14px' }}>{value}</Typography>
    </Box>
  )
}
